import axios from 'axios';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import ReactPaginate from 'react-paginate'
import $ from 'jquery';
import React, { Component, useState } from 'react';
import Cookies from 'universal-cookie';
import "../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../services/ApiRest';
import { Alert } from 'bootstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import * as xlsx from "xlsx";

const cookie = new Cookies();
const baseUrlPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListaEstudTutor = ApiUrl + "listestudmatriperiodotutor" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlGuardarHorasPractica = ApiUrl + "horaspracticaslabestud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlBuscarHorasPractica = ApiUrl + "horaspracticaslabestud/buscar" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListaDocsPracticasEst = ApiUrl + "doc-pract-lab-estud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlRespuestaDocumentos = ApiUrl + "respdocpractlabestud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

const itemsPerPage = 10;

export default class ListarAsigTutPractLab extends Component {

    constructor(props) {
        super(props);
        this.state = {
            periodos: [],
            estud: [],
            EstudianteBackup: [],
            documentosPracticas: [],
            textBuscar: "",
            idPeriodo: "",
            idAdministrativo: "", // ID del tutor logueado

            // Variables para paginación
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            currentPage: 0,

            // Modal horas
            modalHoras: false,
            estudianteSeleccionado: null,
            horasAsignadasPeriodo: "",
            horasCumplidasPeriodo: "",
            observacion: "",
            idHoraPracticaExistente: null,
            listaauxiliar: [],

            // Modal descripción
            modalDescripcionDocumento: false,
            descripcionDocumento: "",

            idEstudianteSelect: null,
            idHorasPractLabEstud: null,
            idCarreraSelect: null,
        };
    }

    componentDidMount() {
        // Cargar períodos
        axios.get(baseUrlPeriodos)
            .then(response => {
                const listaperiodos = response.data.data;
                if (listaperiodos?.length) this.setState({ periodos: listaperiodos });
            });

        // ⚠️ IMPORTANTE: Aquí debes obtener el ID del administrativo/tutor logueado
        // Ejemplo: desde localStorage, props, contexto, etc.
        const idAdministrativoLogueado = cookie.get("idAdministrativo")

        this.setState({ idAdministrativo: idAdministrativoLogueado });
    }

    filter(event) {
        const text = event.target.value;
        const data = this.state.estud;

        let newData = data.filter(function (item) {
            const itemDataPrimerApell = item.primer_apellido_estudiante.toUpperCase();
            const itemDataPrimerNom = item.primer_nombre_estudiante.toUpperCase();
            const itemDataCedula = item.numero_identificacion_estudiante.toUpperCase();
            const campo = itemDataPrimerApell + " " + itemDataPrimerNom + " " + itemDataCedula;
            const textData = text.toUpperCase();
            return campo.indexOf(textData) > -1;
        });

        if (text === "") {
            newData = this.state.EstudianteBackup;
        }

        this.setState({
            currentItems: newData,
            textBuscar: text,
        });
    }

    handlePageClick = ({ selected }) => {
        const { listaauxiliar } = this.state;
        const total = listaauxiliar.length;
        const pageSize = itemsPerPage;

        if (total === 0) return;

        const start = selected * pageSize;
        const end = Math.min(start + pageSize, total);
        const currentItems = listaauxiliar.slice(start, end);

        this.setState({
            currentItems,
            EstudianteBackup: currentItems,
            itemOffset: start,
            currentPage: selected,
        });
    };

    handleChangePeriodo = (e) => {
        const idPeriodoSeleccionado = e.target.value;

        this.setState({
            idPeriodo: idPeriodoSeleccionado,
            listaauxiliar: [],
            estud: [],
            EstudianteBackup: [],
            currentItems: [],
            pageCount: 0,
            itemOffset: 0,
            currentPage: 0,
            documentosPracticas: [], // ✅ Limpiar documentos
            idEstudianteSelect: null, // ✅ Limpiar selección
            idCarreraSelect: null, // ✅ Limpiar carrera
            idHorasPractLabEstud: null, // ✅ Limpiar horas
            estudianteSeleccionado: null, // ✅ Limpiar estudiante
        }, () => {
            // Llamar automáticamente al listar estudiantes
            if (this.state.idPeriodo && this.state.idAdministrativo) {
                this.listarEstudiantesTutor();
            }
        });
    };

    listarEstudiantesTutor = () => {
        const { idPeriodo, idAdministrativo } = this.state;

        if (!idPeriodo || !idAdministrativo) {
            swal("Advertencia", "Seleccione un período", "warning");
            return;
        }

        // Limpiamos estado antes de cargar nueva data
        this.setState({
            listaauxiliar: [],
            estud: [],
            EstudianteBackup: [],
            currentItems: [],
            pageCount: 0,
            itemOffset: 0,
            currentPage: 0,
        });

        axios.post(urlListaEstudTutor, {
            idperiodoe: idPeriodo,
            idadministrativo: idAdministrativo,
        })
            .then((response) => {
                if (response.data.success) {
                    // Ordenar alfabéticamente
                    const listaauxiliar = (response.data.data || []).sort((a, b) => {
                        const ap1 = a.primer_apellido_estudiante.localeCompare(b.primer_apellido_estudiante);
                        if (ap1 !== 0) return ap1;
                        const ap2 = a.segundo_apellido_estudiante.localeCompare(b.segundo_apellido_estudiante);
                        if (ap2 !== 0) return ap2;
                        const nom1 = a.primer_nombre_estudiante.localeCompare(b.primer_nombre_estudiante);
                        if (nom1 !== 0) return nom1;
                        return a.segundo_nombre_estudiante.localeCompare(b.segundo_nombre_estudiante);
                    });

                    const total = listaauxiliar.length;
                    const pageSize = itemsPerPage;
                    const pageCount = Math.ceil(total / pageSize);
                    const currentItems = listaauxiliar.slice(0, pageSize);

                    this.setState({
                        listaauxiliar,
                        estud: listaauxiliar,
                        EstudianteBackup: listaauxiliar,
                        currentItems,
                        pageCount,
                        itemOffset: 0,
                        currentPage: 0,
                    });
                } else {
                    this.setState({
                        listaauxiliar: [],
                        estud: [],
                        EstudianteBackup: [],
                        currentItems: [],
                        pageCount: 0,
                        currentPage: 0,
                    });
                    swal("Información", "No tiene estudiantes asignados en este período", "info");
                }
            })
            .catch(() => swal("Error", "No se pudo conectar con el servidor", "error"));
    };

    seleccionarEstudiantePracticas = async (estudiante) => {
        if (!this.state.idPeriodo) {
            swal("Aviso", "Seleccione un período antes de listar documentos.", "info");
            return;
        }

        await this.setState({
            idEstudianteSelect: estudiante.id_estudiante,
            idHorasPractLabEstud: estudiante.id_hor_prac_lab_est,
            estudianteSeleccionado: estudiante, // ✅ Guardar el estudiante completo
            idCarreraSelect: estudiante.id_carrera // ✅ Guardar específicamente el id_carrera
        });

        axios.post(urlListaDocsPracticasEst, {
            idCarrera: estudiante.id_carrera,
            idEstudiante: estudiante.id_estudiante,
            idPeriodo: this.state.idPeriodo,
        })
            .then(res => {
                if (res.data?.success) {
                    this.setState({ documentosPracticas: res.data.data || [] });
                } else {
                    this.setState({ documentosPracticas: [] });
                    swal("Información", "El estudiante no tiene documentos registrados.", "info");
                }
            })
            .catch(() => {
                this.setState({ documentosPracticas: [] });
                swal("Error", "No se pudo obtener la información.", "error");
            });
    };

    mostrarModalDescripDocumento = (registro) => {
        this.setState({
            modalDescripcionDocumento: true,
            descripcionDocumento: registro || ''
        });
    };

    ocultarModalDescripDocumento = () => {
        this.setState({ modalDescripcionDocumento: false });
    };

    abrirModalHoras = (estudiante) => {
        this.setState({
            estudianteSeleccionado: estudiante,
            modalHoras: true,
            horasAsignadasPeriodo: "",
            horasCumplidasPeriodo: "",
            observacion: "",
            idHoraPracticaExistente: null,
        });

        axios.post(urlBuscarHorasPractica, {
            est_id: estudiante.id_estudiante,
            car_id: estudiante.id_carrera,
            per_id: this.state.idPeriodo,
        })
            .then(res => {
                if (res.data.data) {
                    const h = res.data.data;
                    this.setState({
                        horasAsignadasPeriodo: h.hor_asig,
                        horasCumplidasPeriodo: h.hor_cump,
                        observacion: h.obs || "",
                        idHoraPracticaExistente: h.id,
                    });
                }
            });
    };

    cerrarModal = () => this.setState({ modalHoras: false });

    guardarHorasPractica = async () => {
        const {
            estudianteSeleccionado,
            idPeriodo,
            horasAsignadasPeriodo,
            horasCumplidasPeriodo,
            observacion,
            idHoraPracticaExistente,
        } = this.state;

        if (!estudianteSeleccionado || !idPeriodo) {
            swal("Error", "Seleccione estudiante y período", "error");
            return;
        }

        const horasAsignadas = Number(horasAsignadasPeriodo) || 0;
        const horasCumplidas = Number(horasCumplidasPeriodo) || 0;

        if (horasAsignadas < 0 || horasCumplidas < 0) {
            swal("Error", "Las horas no pueden ser valores negativos.", "warning");
            return;
        }

        if (horasCumplidas > horasAsignadas) {
            swal("Error", "Las horas cumplidas no pueden ser mayores que las asignadas.", "error");
            return;
        }

        const payload = {
            est_id: estudianteSeleccionado.id_estudiante,
            car_id: estudianteSeleccionado.id_carrera,
            per_id: idPeriodo,
            hor_asig: horasAsignadas,
            hor_cump: horasCumplidas,
            obs: observacion || "",
        };

        try {
            if (idHoraPracticaExistente) {
                const urlUpdate = `${ApiUrl}horaspracticaslabestud/${idHoraPracticaExistente}?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71`;
                await axios.put(urlUpdate, payload);
                swal("Actualizado", "Horas prácticas actualizadas correctamente", "success");
            } else {
                await axios.post(urlGuardarHorasPractica, payload);
                swal("Registrado", "Horas prácticas registradas correctamente", "success");
            }

            this.cerrarModal();
            this.listarEstudiantesTutor();

        } catch (error) {
            console.error("Error al guardar:", error);
            swal("Error", "No se pudo procesar el registro", "error");
        }
    };

    handleChangeObservacion = (e, idDocumento) => {
        const nuevaObservacion = e.target.value;
        this.setState((prevState) => ({
            documentosPracticas: prevState.documentosPracticas.map((doc) => {
                if (doc.id_documento_practica_laboral === idDocumento) {
                    return { ...doc, observacion_documento: nuevaObservacion };
                }
                return doc;
            }),
        }));
    };

    modificarInformacionDocumento = (e, doc) => {
        const idBase = this.state.idHorasPractLabEstud + "" + doc.id_documento_practica_laboral;
        const idSelectEstadoDoc = "estdocpractlab" + idBase;
        const idObservcionDoc = "obsdocpractlab" + idBase;
        const idInputFile = "filedocpractlab" + idBase;

        const idEstado = document.getElementById(idSelectEstadoDoc)?.value || 0;
        const observacion = document.getElementById(idObservcionDoc)?.value || "";
        const inputFile = document.getElementById(idInputFile);
        const archivo = inputFile?.files?.[0] || null;

        if (archivo) {
            const allowedTypes = [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ];

            if (!allowedTypes.includes(archivo.type)) {
                swal({
                    text: "El archivo debe ser de tipo PDF o Word (.doc, .docx)",
                    icon: "error",
                    button: "Aceptar",
                });
                return;
            }
        }

        const formData = new FormData();
        formData.append("idestadodocument", idEstado);
        formData.append("observaciondoc", observacion);
        formData.append("iddocumentoestudiante", doc.id_documento_practica_laboral);
        formData.append("idhoraspractlabest", this.state.idHorasPractLabEstud);

        if (archivo) {
            formData.append("archivorevisado", archivo);
        }

        const config = {
            headers: { "Content-Type": "multipart/form-data" },
        };

        axios.post(urlRespuestaDocumentos, formData, config)
            .then((response) => {
                if (response.data.success) {
                    swal({
                        text: "Información actualizada correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });

                    // ✅ Usar idCarreraSelect en lugar de estudianteSeleccionado
                    axios.post(urlListaDocsPracticasEst, {
                        idCarrera: this.state.idCarreraSelect, // ✅ CORRECCIÓN AQUÍ
                        idEstudiante: this.state.idEstudianteSelect,
                        idPeriodo: this.state.idPeriodo,
                    })
                        .then((res) => {
                            if (res.data?.success) {
                                this.setState({ documentosPracticas: res.data.data || [] });
                            }
                        })
                        .catch((error) => {
                            console.error("Error al recargar documentos:", error);
                        });
                } else {
                    swal({
                        text: response.data.message || "Error al actualizar.",
                        icon: "error",
                        button: "Aceptar",
                    });
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                swal({
                    text: "No se pudo conectar con el servidor.",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    };

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">

                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="back-istmas">
                        <i className="fa fa-clock text-white"></i>
                        <b className="ms-2">Gestión Prácticas Laborales - Tutor Académico</b>
                    </div>

                    <div className="row mt-3 text-azul">
                        <div className="col-12 col-sm-6 col-lg-4">
                            <label className="form-label"><b> <i className="fa-magnifying-glass"></i> Buscar:</b></label>
                            <input type="text" class="form-control form-control-sm col-md-12" value={this.state.text} placeholder="Buscar..." onChange={(text) => this.filter(text)} />
                        </div>

                        <div className="col-12 col-sm-6 col-lg-4">
                            <label><b><i className="fa fa-calendar"></i> Período:</b></label>
                            <select
                                className="form-select form-select-sm"
                                name="idPeriodo"
                                onChange={this.handleChangePeriodo}
                                value={this.state.idPeriodo}
                            >
                                <option value="" disabled>Seleccione el período</option>
                                {this.state.periodos.map((p) => (
                                    <option key={p.id_periodo_academico} value={p.id_periodo_academico}>
                                        {p.descripcion_periodo_academico}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {/* Tabla Estudiantes*/}
                    {this.state.idPeriodo && (
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="table-responsive">
                                <table className="table table-sm-custom table-hover">
                                    <thead className="table-light text-azul">
                                        <tr className="text-azul">
                                            <th>Cédula</th>
                                            <th>Primer Apellido</th>
                                            <th>Segundo Apellido</th>
                                            <th>Primer Nombre</th>
                                            <th>Segundo Nombre</th>
                                            <th>Carrera</th>
                                            <th>Entidad Formadora</th>
                                            <th>Tutor Empresarial</th>
                                            <th>Horas Período</th>
                                            <th>Horas Cumplidas Periodo</th>
                                            <th>Horas Faltantes Periodo</th>
                                            <th>Estado</th>
                                            <th>Documentos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.currentItems && this.state.currentItems.length > 0 ? (
                                            this.state.currentItems.map((estud) => (
                                                <tr key={estud.id_estudiante}>
                                                    <td>{estud.numero_identificacion_estudiante}</td>
                                                    <td>{estud.primer_apellido_estudiante}</td>
                                                    <td>{estud.segundo_apellido_estudiante}</td>
                                                    <td>{estud.primer_nombre_estudiante}</td>
                                                    <td>{estud.segundo_nombre_estudiante}</td>

                                                    {/* Carrera */}
                                                    <td>{estud.nombre_carrera || 'N/A'}</td>

                                                    {/* Entidad Formadora */}
                                                    <td>
                                                        <span
                                                            className="d-inline-block text-truncate"
                                                            style={{ maxWidth: '200px' }}
                                                            title={estud.nombre_entidad_formadora}
                                                        >
                                                            {estud.nombre_entidad_formadora || 'Sin asignar'}
                                                        </span>
                                                    </td>

                                                    {/* Tutor Empresarial */}
                                                    <td>
                                                        {estud.nombre_tutor_empresarial && estud.nombre_tutor_empresarial.trim() ? (
                                                            <span>{estud.nombre_tutor_empresarial.trim()}</span>
                                                        ) : (
                                                            <span className="text-muted">Sin asignar</span>
                                                        )}
                                                    </td>

                                                    <td>{estud.hor_asig || 0}</td>
                                                    <td>{estud.hor_cump || 0}</td>
                                                    <td>{(estud.hor_asig || 0) - (estud.hor_cump || 0)}</td>

                                                    <td>
                                                        {(() => {
                                                            const totalRequeridos = estud.total_docs_requeridos || 0;
                                                            const totalAprobados = estud.total_docs_aprobados || 0;
                                                            const tieneDocumentosPendientes = estud.est_doc_aprobdocen == 1;

                                                            // ✅ Si no tiene documentos requeridos, no mostrar nada
                                                            if (totalRequeridos === 0) {
                                                                return null;
                                                            }

                                                            // ✅ COMPLETADO: Todos los documentos aprobados
                                                            if (totalAprobados === totalRequeridos) {
                                                                return (
                                                                    <span className="badge bg-success text-white small rounded-pill">
                                                                        <i className="fas fa-check-circle me-1"></i>
                                                                        Completado
                                                                    </span>
                                                                );
                                                            }

                                                            // ✅ PROCESAR: Tiene documentos enviados pendientes de revisar
                                                            if (tieneDocumentosPendientes) {
                                                                return (
                                                                    <span className="badge bg-warning text-dark small rounded-pill">
                                                                        <i className="fas fa-clock me-1"></i>
                                                                        Procesar
                                                                    </span>
                                                                );
                                                            }

                                                            // ✅ Si tiene documentos pero ninguno está en estado "Enviado", no mostrar nada
                                                            return null;
                                                        })()}
                                                    </td>

                                                    <td>
                                                        {Number(estud.id_horas_practicas_lab_estud) !== 0 ? (
                                                            <input
                                                                type="radio"
                                                                value="1"
                                                                name="interfazdocument"
                                                                onChange={() => this.seleccionarEstudiantePracticas(estud)}
                                                            />
                                                        ) : (
                                                            <span className="text-muted">-</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="13" className="text-center text-muted">
                                                    No tiene estudiantes asignados en este período
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <div className="d-flex justify-content-center mt-4">
                                    <ReactPaginate
                                        previousLabel="<"
                                        nextLabel=">"
                                        pageCount={this.state.pageCount}
                                        onPageChange={this.handlePageClick}
                                        forcePage={this.state.currentPage || 0}
                                        containerClassName="pagination pagination-sm-custom"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        activeClassName="active"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                    {/* ===================== DOCUMENTOS ===================== */}
                    {this.state.idEstudianteSelect && (
                    <div className="p-3 rounded-3 mt-3">
                        <h6 className="fw-bold text-center mb-3 text-azul">
                            Reporte de Documentos de Prácticas Laborales
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-hover table-sm-custom">
                                <thead className="table-light">
                                    <tr className="text-start text-azul">
                                        <th>No</th>
                                        <th>Nombre</th>
                                        <th>Descripción</th>
                                        <th>Formato</th>
                                        <th>Archivo Subido</th>
                                        <th>Fecha de Envío</th>
                                        <th>Observación</th>
                                        <th>Cargar</th>
                                        <th>Estado</th>
                                        <th>Responder</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(this.state.documentosPracticas) && this.state.documentosPracticas.length > 0 ? (
                                        this.state.documentosPracticas.map((doc, index) => (
                                            <tr className="text-start text-azul" key={doc.id_registro || index}>
                                                <td>{index + 1}</td>
                                                <td>{doc.nombre_documento}</td>
                                                <td>
                                                    <button
                                                        onClick={() => this.mostrarModalDescripDocumento(doc.descripcion_documento)}
                                                        style={{ background: "none", border: "none", cursor: "pointer" }}
                                                        title="Ver descripción"
                                                    >
                                                        <i className="fa fa-2x fa-align-left text-primary"></i>
                                                    </button>
                                                </td>
                                                <td>
                                                    {doc.ruta_formato ? (
                                                        <a href={doc.ruta_formato} target="_blank" rel="noopener noreferrer">
                                                            <i className="fa fa-2x fa-file-alt text-danger"></i>
                                                        </a>
                                                    ) : (
                                                        <span className="small text-muted">Sin archivo</span>
                                                    )}
                                                </td>
                                                <td>
                                                    {doc.ruta_cargada ? (
                                                        <a href={doc.ruta_cargada} target="_blank" rel="noopener noreferrer">
                                                            <i className="fa fa-2x fa-file-alt text-success"></i>
                                                        </a>
                                                    ) : (
                                                        <span className="small text-muted">Sin archivo</span>
                                                    )}
                                                </td>
                                                <td>{doc.fecha_envio || "-"}</td>
                                                <td>
                                                    <textarea
                                                        name={`obsdocpractlab${this.state.idHorasPractLabEstud}${doc.id_documento_practica_laboral}`}
                                                        id={`obsdocpractlab${this.state.idHorasPractLabEstud}${doc.id_documento_practica_laboral}`}
                                                        onChange={(e) => this.handleChangeObservacion(e, doc.id_documento_practica_laboral)}
                                                        className="form-control"
                                                        maxLength="500"
                                                        value={doc.observacion_documento || ''}
                                                        disabled={doc.estado_documento === 2}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="file"
                                                        accept=".pdf,.doc,.docx"
                                                        id={`filedocpractlab${this.state.idHorasPractLabEstud}${doc.id_documento_practica_laboral}`}
                                                        className="form-control form-control-sm"
                                                        disabled={doc.estado_documento === 2}
                                                    />
                                                </td>
                                                <td>
                                                    {doc.estado_documento === 2 ? (
                                                        // ✅ Si está aprobado por supervisor, solo mostrar el estado como texto
                                                        <span className="badge bg-success">
                                                            Aprobado por supervisor
                                                        </span>
                                                    ) : (
                                                        // ✅ Si no está aprobado por supervisor, mostrar select normal
                                                        <select
                                                            className="form-select"
                                                            name={`estdocpractlab${this.state.idHorasPractLabEstud}${doc.id_documento_practica_laboral}`}
                                                            id={`estdocpractlab${this.state.idHorasPractLabEstud}${doc.id_documento_practica_laboral}`}
                                                            defaultValue={doc.estado_documento || "0"}
                                                        >
                                                            <option value="0">Seleccione</option>
                                                            <option value="1">Enviado</option>
                                                            <option value="3">Rechazado</option>
                                                            <option value="4">Aprobado por el tutor/a</option>
                                                        </select>
                                                    )}
                                                </td>
                                                <td>
                                                    {doc.estado_documento === 0 ? (
                                                        <span className="small text-muted">Pendiente</span>
                                                    ) : doc.estado_documento === 2 ? (
                                                        // ✅ Si está aprobado por supervisor, mostrar mensaje
                                                        <span className="small text-success">
                                                            <i className="fas fa-check-circle"></i> Aprobado
                                                        </span>
                                                    ) : (
                                                        // ✅ Botón que cambia de color según el estado
                                                        <button
                                                            onClick={(e) => this.modificarInformacionDocumento(e, doc)}
                                                            className={`btn btn-sm rounded-pill ${doc.estado_documento === 1 ? 'btn-warning' : 'btn-secondary'
                                                                }`}
                                                            title={doc.estado_documento === 1 ? 'Documento enviado - Clic para responder' : 'Respuesta enviada'}
                                                        >
                                                            <i className="fas fa-clipboard-check"></i>
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center text-muted">
                                                No existen documentos para mostrar
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <Modal isOpen={this.state.modalDescripcionDocumento}>
                            <ModalHeader>
                                <h5>Descripción del Documento</h5>
                            </ModalHeader>
                            <ModalBody>
                                <div className="mb-3 centrar">
                                    <p className="texto-justificado">{this.state.descripcionDocumento}</p>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <button
                                    className="btn btn-outline-primary"
                                    onClick={this.ocultarModalDescripDocumento}
                                >
                                    Cerrar
                                </button>
                            </ModalFooter>
                        </Modal>
                    </div>
                    )}
                </div>

            </div>
        );
    }
}


